import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconClipboard = createIcon({
  displayName: 'IconClipboard',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M8 8H16V2H8V8ZM14 6H10V4H14V6ZM4 22H20V3H18V20H6V3H4V22ZM16 16H8V18H16V16ZM8 12H16V14H8V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
